import { Component } from '@angular/core';

@Component({
  selector: 'mprd-modem-choice-vlan-skeleton',
  templateUrl: './modem-choice-vlan-skeleton.component.html',
})
export class ModemChoiceVlanSkeletonComponent {}
